/**
 *
 * @param func
 * @param wait
 * @param immediate
 * @returns {function(...[*]=)}
 */
export const debounce = function( func, wait, immediate ) {
	let timeout;

	return function() {
		const self = this;
		const	args = arguments;

		/**
		 * Debounced function
		 */
		const debounced = function() {
			timeout = null;
			if ( !immediate ) {
				func.apply( self, args );
			}
		};

		const callNow = immediate && !timeout;

		clearTimeout( timeout );

		timeout = setTimeout( debounced, wait );

		if ( callNow ) {
			func.apply( self, args );
		}
	};
};
